import { gql } from '@apollo/client'
import { CORE_COACHING_KIND_FIELDS } from '@src/graphql/fragments/coachingKind'

export const FETCH_COACH_ASSIGNMENTS = gql`
  ${CORE_COACHING_KIND_FIELDS}
  query coachAssignments(
    $page: Int
    $perPage: Int
    $sorts: [CoachAssignmentSort!]
    $dynamicFilters: [CoachAssignmentDynamicFilterItem!]
  ) {
    coachAssignments(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      coachAssignments {
        id
        state
        supportType
        referralUrl
        coach {
          id
          firstName
          lastName
          coachProfile {
            fullName
            bio
            getHealthieId
            photo
            credentials
            endDate
            averageRating
            reviewsCount
            specialties {
              key
              name
            }
          }
        }
        coachingKind {
          ...CoreCoachingKindFields
        }
      }
    }
  }
`
